SectionProfile.Event.Stickers = Class(
	/**
	 * @lends {SectionProfile.Event.Stickers#}
	 */
	{
		__NAME: 'SectionProfile.Event.Stickers',

		bodyClass: 'small-nav grey hide-tablet-footer full-container stickers-page',
		name: 'stickers',

		/** @type {DR.users.struct.MyData} */
		user: null,
		/** @type {DR.teams.struct.Team} */
		team: null,

		_steps: [],
		_stepsMap: {},

		_postalFields: {},
		_omnivaFields: {},

		/** @type {SectionProfile.Event.Stickers.Omniva} */
		_omniva: null,

		_addressType: 'postal',

		pickupLocations: null,

		_draw: function () {
			this._mPreparePurchase = new DR.services.PreparePurchaseStickers();
			this._mPreparePurchase.onLoad = this._mPreparePurchaseRe;
			this.apiCall.addMethod(this._mPreparePurchase);

			this._mGetMyData = new DR.users.GetMyData();
			this._mGetMyData.onLoad = this._mGetMyDataRe;
			this._mGetMyData.select = [
				new DR.users.select.MyData().user().team(),
				new DR.users.select.User().id().name().surname(),
				new DR.teams.select.Team().id().title().isPaid().stickers().sequence().users().captain()
			];
			this.apiCall.addMethod(this._mGetMyData);

			this._mGetPickupLocations = new DR.services.GetPickupLocations();
			this.apiCall.addMethod(this._mGetPickupLocations);

			this._omniva = new SectionProfile.Event.Stickers.Omniva(this.apiCall);
		},

		_mPreparePurchaseRe: function () {
			this.data = this._mPreparePurchase.re;
		},

		_mGetMyDataRe: function () {
			this.user = this._mGetMyData.re.user;
			this.team = this._mGetMyData.re.team;
		},

		_ready: function () {
			if( !this.team || !this.event.settings.hasStickers ) {
				Section.navigate(D.url('/profile/event/' + this.event.seoTitle));
				return;
			}

			this._drawTabs();
			this._drawSidebar();

			if( this._mGetPickupLocations.re.locations.length > 0 ) {
				this.rpc = new RPC('/api/web_rpc.php?EVENT_ID=' + this.event.id);
				if( this.team.stickers.freeStickers ) {
					this._drawPickupCompleted();
				} else {
					this._drawPickup();
				}
				return;
			}

			if( this.url.get.is('pmt-success') ) {
				let success = [
					D.Lang.get('profile.team.purchase.success_short')
				];
				this._successMsg = mkE({
					tag: 'div',
					className: 'message stickers-pmt-success',
					els: [
						T.success(success)
					]
				}).prepend(this._content);
			}

			const paidStickers = this.event.settings.hasCustomStickers ? this.team.stickers.paidStickers : true;

			if( this.team.stickers.freeStickers && paidStickers ) {
				let stickersEl = mkE({
					tag: 'div',
					className: 'stickers-completed',
					els: [
						{
							tag: 'div',
							className: 'stickers-step stickers-step-choose'
						},
						{
							tag: 'h1',
							text: D.Lang.get('profile.stickers.completed.title')
						},
						{
							tag: 'p',
							text: D.Lang.get('profile.stickers.completed.description')
						}
					]
				}).append(this._content);

				this._drawStickers().append(stickersEl);
				return;
			}

			this._drawWizard();
		},

		_pickupLocationNodes: [],

		_drawPickup: function () {
			let countries = [];
			let defaultCountry = null;
			for( let i = 0; i < this._mGetPickupLocations.re.locations.length; i++ ) {
				const location = this._mGetPickupLocations.re.locations[i];
				if( countries.indexOf(location.country) === -1 ) {
					countries.push(location.country);
					if( location.country === D.LANG ) {
						defaultCountry = location.country;
					}
				}
			}
			if( !defaultCountry ) {
				defaultCountry = countries[0];
			}
			mkE({
				tag: 'div',
				className: 'stickers-pickup',
				els: [
					{
						tag: 'div',
						className: 'header',
						els: [
							this._pickupErrorNode = mkE({
								tag: 'div',
								className: 'message stickers-pmt-success'
							}),
							{
								tag: 'h2',
								text: D.Lang.get('profile.stickers.pickup.title')
							},
							{
								tag: 'div',
								className: 'row',
								els: [
									{
										tag: 'div',
										className: 'info',
										els: [
											{
												tag: 'p',
												text: D.Lang.get('profile.stickers.pickup.description')
											},
											{
												tag: 'p',
												className: 'disclaimer',
												text: D.Lang.get('profile.stickers.pickup.disclaimer')
											}
										]
									},
									{
										tag: 'div',
										els: [
											this._drawSticker('triangle', (new Get('/stickers/zemgale/triangle.php').add('id', String(this.team.sequence)).toUrl()), true)
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'form',
						els: [
							{
								tag: 'div',
								className: 'form-row',
								els: [
									{
										tag: 'div',
										className: 'title',
										els: [
											{
												tag: 'strong',
												text: D.Lang.get('profile.stickers.pickup.form.country')
											}
										]
									},
									{
										tag: 'div',
										className: 'countries',
										els: (() => {
											let els = [];
											for( let i = 0; i < countries.length; i++ ) {
												const country = countries[i];
												els.push({
													tag: 'label',
													els: [
														{
															tag: 'input',
															type: 'radio',
															name: 'country',
															checked: country === defaultCountry,
															onchange: this._onPickupCountryChange,
															value: country
														},
														{
															tag: 'div',
															className: 'item item-country',
															els: [
																{
																	tag: 'span',
																	className: `flag-icon flag-icon-${country}`,
																	style: {
																		backgroundImage: `url('/images/vendor/flag-icon-css/flags/4x3/${country}.svg')`
																	}
																},
																{
																	tag: 'span',
																	text: D.Lang.get(`iso.countries.${country}`)
																}
															]
														}
													]
												});
											}
											return els;
										})()
									}
								]
							},
							{
								tag: 'div',
								className: 'form-row',
								els: [
									{
										tag: 'div',
										className: 'title',
										els: [
											{
												tag: 'strong',
												text: D.Lang.get('profile.stickers.pickup.form.pickup-point')
											}
										]
									},
									{
										tag: 'div',
										els: (() => {
											let els = [];
											let first = false;
											for( let i = 0; i < this._mGetPickupLocations.re.locations.length; i++ ) {
												const location = this._mGetPickupLocations.re.locations[i];
												const locationNode = mkE({
													tag: 'input',
													type: 'radio',
													name: 'address',
													value: location.id,
													disabled: location.country !== defaultCountry,
													attr: {
														'data-country': location.country,
														'data-placeholder': location.city === 'placeholder' ? 1 : 0
													}
												});
												if( !locationNode.disabled && !first ) {
													first = true;
													locationNode.checked = true;
												}
												this._pickupLocationNodes.push(locationNode);
												els.push({
													tag: 'label',
													els: [
														locationNode,
														{
															tag: 'div',
															className: 'item',
															text: location.title
														}
													]
												})
											}
											return els;
										})()
									}
								]
							},
							{
								tag: 'div',
								className: 'button-container',
								els: [
									this._pickupLocationConfirm = mkE({
										tag: 'button',
										className: 'button button-large button-pink',
										onclick: this._onSubmitPickupPoint,
										text: D.Lang.get('profile.stickers.pickup.submit')
									})
								]
							}
						]
					}
				]
			}).append(this._content);
		},

		_onPickupCountryChange: function ( e ) {
			const country = e.target.value;
			let first = false;
			for( let i = 0; i < this._pickupLocationNodes.length; i++ ) {
				const pickupLocationNode = this._pickupLocationNodes[i];
				pickupLocationNode.disabled = pickupLocationNode.dataset.country !== country
				if( !pickupLocationNode.disabled && !first ) {
					first = true;
					pickupLocationNode.checked = true;
					this._pickupLocationConfirm.disabled = pickupLocationNode.dataset.placeholder === "1";
				}
			}
		},

		_onSubmitPickupPoint: function () {
			if( this._isPurchasing ) {
				return;
			}
			const id = +this._content.querySelector('[name="address"]:checked').value || 0;
			if( !id ) {
				return;
			}
			this._isPurchasing = true;
			for( let i = 0; i < this._mGetPickupLocations.re.locations.length; i++ ) {
				const location = this._mGetPickupLocations.re.locations[i];
				if( location.id === id ) {
					this._mGetPickupLocations.re.selected = location;
				}
			}
			this.rpc.send(
				'purchaseStickers',
				{
					free: true,
					shipping: {
						type: 'pickup',
						id: id
					}
				},
				this._onSubmitPickupPointRe
			);
		},

		_onSubmitPickupPointRe: function ( data ) {
			if( data.ok ) {
				clearNode(this._content);
				this._drawPickupCompleted(D.Lang.get('profile.stickers.pickup.success'));
				window.scroll(0, 0);
				return;
			}
			this._isPurchasing = false;
			if( data.errors ) {
				//
			}
			window.scroll(0, 0);
			clearNode(this._pickupErrorNode);
			T.error(D.Lang.get('profile.stickers.pickup.error')).append(this._pickupErrorNode);
		},

		_drawPickupCompleted: function ( msg ) {
			msg = msg || null;
			mkE({
				tag: 'div',
				className: 'stickers-pickup',
				els: [
					{
						tag: 'div',
						className: 'header',
						els: [
							msg ? {
								tag: 'div',
								className: 'message stickers-pmt-success',
								els: [
									T.success(msg)
								]
							} : '',
							{
								tag: 'div',
								className: 'row',
								els: [
									{
										tag: 'div',
										className: 'info',
										els: [
											{
												tag: 'p',
												innerHTML: D.Lang.get('profile.stickers.pickup.selected').replace('%SELECTED_LOCATION%', this._mGetPickupLocations.re.selected?.title || ' n/a ')
											},
											{
												tag: 'p',
												className: 'disclaimer',
												text: D.Lang.get('profile.stickers.pickup.disclaimer')
											}
										]
									},
									{
										tag: 'div',
										els: [
											this._drawSticker('triangle', (new Get('/stickers/zemgale/triangle.php').add('id', String(this.team.sequence)).toUrl()), true)
										]
									}
								]
							}
						]
					}
				]
			}).append(this._content);
		},

		_drawWizard: function () {
			this.rpc = new RPC('/api/web_rpc.php?EVENT_ID=' + this.event.id);

			this._initSteps();
			this._wizard = new T.Wizard({
				getSteps: this._getSteps,
				returnUrl: D.url('/profile/stickers'),
				onStepChange: () => {
					$(window).scrollTop(0);
					if( this._successMsg ) {
						this._successMsg.remove();
						this._successMsg = null;
					}
				}
			});
			this._wizard.append(this._content);
		},

		_getSteps: function () {
			return this._steps;
		},

		_initSteps: function () {
			this._stepsMap['stickers'] = new T.Wizard.Step({
				getContent: mkE({
					tag: 'div',
					els: [
						{
							tag: 'div',
							className: 'stickers-step stickers-step-choose',
							els: [
								{
									tag: 'h1',
									text: D.Lang.get('profile.stickers.choose.title')
								},
								{
									tag: 'p',
									els: [
										D.Lang.get('profile.stickers.choose.description'),
										this.event.settings.hasCustomStickers ? ' ' + D.Lang.get('profile.stickers.choose.description2') : ''
									]
								},
								this._drawStickers()
							]
						},
						{
							tag: 'div',
							className: 'stickers-step stickers-step-address',
							els: [
								this._addressTitle = mkE({
									tag: 'h1',
									text: D.Lang.get('profile.stickers.address.title')
								}),
								this._addressDescription = mkE({
									tag: 'p',
									text: D.Lang.get('profile.stickers.address.description')
								}),
								this._drawAddress()
							]
						}
					]
				}),
				canContinue: false,
				continueText: D.Lang.get('profile.stickers.continue'),
				continueAction: this._checkAddress,
				onActivate: this._checkStickers,
				bottomContent: this.event.settings.hasCustomStickers ? mkE({
					tag: 'div',
					className: 'info',
					text: D.Lang.get('profile.stickers.remind')
				}) : null,
				stepClass: 'step0'
			});
			this._steps.push(this._stepsMap['stickers']);

			this._bottomPriceNode = mkE({
				tag: 'div',
				className: 'stickers-pricing-bottom',
				els: [
					this._bottomPriceText = mkE({
						tag: 'div',
						className: 'price',
						text: '€15.00'
					})
				]
			});

			this._stepsMap['payment'] = new T.Wizard.Step({
				getContent: mkE({
					tag: 'div',
					className: 'stickers-step stickers-step-payment',
					els: [
						{
							tag: 'h1',
							text: D.Lang.get('profile.stickers.payment.title')
						},
						{
							tag: 'p',
							text: D.Lang.get('profile.stickers.payment.description')
						},
						{
							tag: 'div',
							className: 'stickers-purchase-data',
							els: [
								this._purchaseForm = new T.PurchaseForm(),
								this._rulesCheckbox = new T.Form.CheckBox({
									caption: [
										D.Lang.get('profile.team.purchase.agree') + ' ',
										{
											tag: 'a',
											href: D.url('terms'),
											target: '_blank',
											text: D.Lang.get('profile.team.purchase.terms')
										},
										' ' + D.Lang.get('profile.team.purchase.and') + ' ',
										{
											tag: 'a',
											href: D.url('privacy-policy'),
											target: '_blank',
											text: D.Lang.get('profile.team.purchase.privacy_policy')
										}
									],
									small: true,
									onChange: D.closure(this, function () {
										if( this._rulesCheckbox.value() ) {
											this._rulesCheckbox.error(null);
										}
									})
								}),
								{
									tag: 'div',
									className: 'price-info',
									els: [
										{
											tag: 'h3',
											els: [
												{
													tag: 'span',
													text: '€15.00'
												}
											]
										}
									]
								},
								{
									tag: 'div',
									className: 'purchase-disclaimer',
									els: [
										{
											tag: 'div',
											className: 'disclaimer',
											els: [
												D.Lang.get('profile.team.purchase.receiver'),
												{
													tag: 'br'
												},
												D.Lang.get('profile.team.purchase.address')
											]
										},
										{
											tag: 'img',
											src: '/assets/images/payments.svg'
										}
									]
								}
							]
						}
					]
				}),
				canGoBack: true,
				canContinue: true,
				continueText: D.Lang.get('profile.stickers.continue'),
				continueAction: this._checkPaymentData,
				bottomContent: this._bottomPriceNode
			});
			this._steps.push(this._stepsMap['payment']);

			this._stepsMap['review'] = new T.Wizard.Step({
				getContent: mkE({
					tag: 'div',
					className: 'stickers-step stickers-step-review',
					els: [
						this._errorHolder = mkE({
							tag: 'div'
						}),
						{
							tag: 'h1',
							text: D.Lang.get('profile.stickers.review.title')
						},
						{
							tag: 'p',
							text: D.Lang.get('profile.stickers.review.description')
						},
						this._reviewContainer = mkE({
							tag: 'div',
							className: 'stickers-review'
						})
					]
				}),
				canGoBack: true,
				canContinue: true,
				continueText: D.Lang.get('profile.stickers.purchase'),
				continueAction: this._getStickers,
				onActivate: this._drawReview,
				bottomContent: this._bottomPriceNode
			});
			this._steps.push(this._stepsMap['review']);
			this._updateSteps();
		},

		_drawStickers: function () {
			let triangle = new Get('/stickers/zemgale/triangle.php');
			triangle.add('id', String(this.team.sequence));
			triangle = triangle.toUrl();

			let square = new Get('/stickers/zemgale/name.php');
			square.add('id', String(this.team.sequence));
			square.add('name', this.team.title);
			square = square.toUrl();

			let bumper = '/stickers/zemgale/rg-bumper.png';

			let names = new Get('/stickers/zemgale/names.php');
			for( let i = 0, l = this.team.users.length; i < l; i++ ) {
				names.add('names[' + i + ']', this.team.users[i].name.substr(0, 1).toUpperCase() + '. ' + this.team.users[i].surname.toUpperCase());
			}
			names = names.toUrl();

			let stickersToggle = mkE({
				tag: 'div',
				className: 'stickers-toggle'
			});

			mkE({
				tag: 'div',
				id: 'free-stickers',
				className: 'stickers-toggle-item stickers-toggle-open',
				els: [
					this._freeStickersCaption = mkE({
						tag: 'div',
						className: 'stickers-toggle-caption'
					}),
					{
						tag: 'div',
						className: 'stickers-toggle-content',
						els: [
							{
								tag: 'div',
								className: 'stickers-grid',
								els: [
									this._drawSticker('triangle', triangle),
									{
										tag: 'div',
										className: 'disclaimer',
										els: [
											{
												tag: 'span',
												text: D.Lang.get('profile.stickers.disclaimer')
											},
											{
												tag: 'div',
												className: 'description',
												text: D.Lang.get('profile.stickers.stickers.triangle')
											}
										]

									}
								]
							}
						]
					}
				]
			}).append(stickersToggle);
			this._drawFreeStickersCaption();

			if( this.event.settings.hasCustomStickers ) {
				mkE({
					tag: 'div',
					id: 'paid-stickers',
					className: 'stickers-toggle-item stickers-toggle-open',
					els: [
						this._paidStickersCaption = mkE({
							tag: 'div',
							className: 'stickers-toggle-caption'
						}),
						{
							tag: 'div',
							className: 'stickers-toggle-content',
							els: [
								{
									tag: 'div',
									className: 'stickers-grid',
									els: [
										this._drawSticker('square', square),
										this._drawSticker('bumper', bumper),
										this._drawSticker('names', names)
									]
								}

							]
						}
					]
				}).append(stickersToggle);
				this._drawPaidStickersCaption();
			}

			return stickersToggle;
		},

		_drawFreeStickersCaption: function () {
			clearNode(this._freeStickersCaption);
			let hasFree = Boolean(this.team.stickers.freeStickers);
			if( !hasFree ) {
				this._getFreeStickers = new T.Form.CheckBox({
					type: 'checkbox',
					checked: true,
					disabled: true,
					onChange: this._checkStickers
				}).append(this._freeStickersCaption);
			}
			mkE({
				tag: 'div',
				className: 'title' + (hasFree ? ' title-has' : ''),
				text: D.Lang.get('profile.stickers.choose.free')
			}).append(this._freeStickersCaption);
			if( !hasFree ) {
				mkE({
					tag: 'div',
					className: 'price',
					text: '€0.00'
				}).append(this._freeStickersCaption);
			} else {
				mkE({
					tag: 'div',
					className: 'sticker-bought',
					text: D.Lang.get('profile.stickers.bought')
				}).append(this._freeStickersCaption);
			}
		},

		_drawPaidStickersCaption: function () {
			clearNode(this._paidStickersCaption);
			let hasPaid = Boolean(this.team.stickers.paidStickers);
			if( !hasPaid ) {
				this._getPaidStickers = new T.Form.CheckBox({
					type: 'checkbox',
					onChange: this._checkStickers
				}).append(this._paidStickersCaption);
			}
			mkE({
				tag: 'div',
				className: 'title' + (hasPaid ? ' title-has' : ''),
				text: D.Lang.get('profile.stickers.choose.paid')
			}).append(this._paidStickersCaption);
			if( !hasPaid ) {
				mkE({
					tag: 'div',
					className: 'price',
					text: '€15.00'
				}).append(this._paidStickersCaption);
			} else {
				mkE({
					tag: 'div',
					className: 'sticker-bought',
					text: D.Lang.get('profile.stickers.bought')
				}).append(this._paidStickersCaption);
			}
		},

		_checkStickers: function () {
			let canContinue = false;
			let hasPaid = false;
			if( this._getFreeStickers && this._getFreeStickers.value() ) {
				canContinue = true;
			}
			if( this._getPaidStickers && this._getPaidStickers.value() ) {
				canContinue = true;
				hasPaid = true;
			}

			this._stepsMap['stickers'].setCanContinue(canContinue);
			this._stepsMap['review'].setContinueText(D.Lang.get(hasPaid ? 'profile.stickers.purchase' : 'profile.stickers.getSticker'));
			setNodeText(this._bottomPriceText, hasPaid ? '€15.00' : '');
			this._updateSteps(hasPaid);

			this._onShowAddress();
		},

		_drawSticker: function ( type, url, noDescription ) {
			let stickerImage = mkE({
				tag: 'div',
				className: 'image image-' + type
			});
			let sticker = mkE({
				tag: 'div',
				className: 'sticker sticker-' + type,
				els: [
					stickerImage,
					noDescription ? null : {
						tag: 'div',
						className: 'description',
						text: D.Lang.get('profile.stickers.stickers.' + type)
					}
				]
			});

			// if (type === 'names') {
			// 	mkE({
			// 		tag: 'div',
			// 		className: 'names-sticker',
			// 		style: {
			// 			backgroundImage: 'url("' + url + '")'
			// 		}
			// 	}).append(stickerImage);
			// }
			// if (type !== 'names') {
			//     stickerImage.style.backgroundImage = 'url("' + url + '")';
			// }

			if( type !== 'names' ) {
				mkE({
					tag: 'div',
					className: 'image-preview',
					els: [
						{
							tag: 'div',
							className: 'img',
							style: {
								backgroundImage: 'url("' + url + '")'
							}
						}
					]
				}).append(stickerImage);
			} else {
				mkE({
					tag: 'div',
					className: 'image-preview image-names',
					els: [
						{
							tag: 'div',
							className: 'img',
							els: [
								{
									tag: 'div',
									className: 'names-sticker',
									style: {
										backgroundImage: 'url("' + url + '")'
									}
								}
							]
						}

					]
				}).append(stickerImage);
			}

			mkE({
				tag: 'div',
				className: 'overlay',
				prop: {
					onmouseenter: D.closure(this, this._showPreview, sticker),
					onmouseout: D.closure(this, this._hidePreview, sticker),
					onclick: D.closure(this, this._togglePreview, sticker)
				}
			}).append(stickerImage);

			// mkE({
			// 	tag: 'button',
			// 	className: 'image-eye',
			// 	prop: {
			// 		onmouseenter: D.closure(this, this._showPreview, sticker),
			// 		onmouseout: D.closure(this, this._hidePreview, sticker),
			// 		onclick: D.closure(this, this._togglePreview, sticker)
			// 	}
			// }).append(sticker);
			return sticker;
		},

		_showPreview: function ( sticker ) {
			addClassName(sticker, 'in-preview');
		},

		_hidePreview: function ( sticker ) {
			if( sticker.isPreview ) {
				return;
			}
			removeClassName(sticker, 'in-preview');
		},

		_togglePreview: function ( sticker ) {
			if( sticker.isPreview ) {
				sticker.isPreview = false;
				removeClassName(sticker, 'in-preview-click');
				this._hidePreview(sticker);
			} else {
				sticker.isPreview = true;
				addClassName(sticker, 'in-preview-click');
				this._showPreview(sticker);
			}
		},

		_updateSteps: function ( hasPaid ) {
			if( hasPaid ) {
				this._steps = [
					this._stepsMap['stickers'],
					this._stepsMap['payment'],
					this._stepsMap['review']
				];
			} else {
				this._steps = [
					this._stepsMap['stickers'],
					this._stepsMap['review']
				];
			}
			if( this._wizard ) {
				this._wizard.drawHeader(this._steps);
			}
		},

		_drawAddress: function () {
			let address = mkE({
				tag: 'div',
				className: 'stickers-address',
				els: [
					this._postalAddress = mkE({
						tag: 'div',
						className: 'stickers-address-postal'
					}),
					this._omnivaAddress = mkE({
						tag: 'div',
						className: 'stickers-address-omniva'
					})
				]
			});
			this._drawPostalForm();
			this._drawOmnivaForm();
			return address;
		},

		_onShowAddress: function () {
			let showOmniva = false;
			if( this._getPaidStickers && this._getPaidStickers.value() ) {
				showOmniva = true;
			}
			if( showOmniva ) {
				this._addressType = 'omniva';
				addClassName(this._postalAddress, 'hide');
				removeClassName(this._omnivaAddress, 'hide');
				setNodeText(this._addressTitle, D.Lang.get('profile.stickers.address.omniva.title'));
				setNodeText(this._addressDescription, D.Lang.get('profile.stickers.address.omniva.description'));
			} else {
				this._addressType = 'postal';
				removeClassName(this._postalAddress, 'hide');
				addClassName(this._omnivaAddress, 'hide');
				setNodeText(this._addressTitle, D.Lang.get('profile.stickers.address.title'));
				setNodeText(this._addressDescription, D.Lang.get('profile.stickers.address.description'));
			}
		},

		_drawPostalForm: function () {
			let countries = [];
			for( let cc in D.countries[D.LANG] ) {
				if( !D.countries[D.LANG].hasOwnProperty(cc) ) {
					continue;
				}
				countries.push({
					value: cc,
					caption: D.countries[D.LANG][cc]
				});
			}
			mkE({
				tag: 'div',
				className: 'form-row form-row-2',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._postalFields['name'] = new T.Form.Input({
								caption: D.Lang.get('profile.stickers.address.form.name'),
								border: true,
								value: this.data.paymentInfo.name || ''
							})
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							this._postalFields['phone'] = new T.Form.Phone({
								caption: D.Lang.get('profile.stickers.address.form.phone'),
								border: true,
								code: Number(this.data.paymentInfo.phoneCode || 371),
								value: this.data.paymentInfo.phone || ''
							})
						]
					}
				]
			}).append(this._postalAddress);
			mkE({
				tag: 'div',
				className: 'form-row form-row-3',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._postalFields['city'] = new T.Form.Input({
								caption: D.Lang.get('profile.stickers.address.form.city'),
								border: true
							})
						]
					},
					{
						tag: 'div',
						className: 'center',
						els: [
							this._postalFields['zip'] = new T.Form.Input({
								caption: D.Lang.get('profile.stickers.address.form.zip'),
								border: true
							})
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							this._postalFields['country'] = new T.Form.Select({
								caption: D.Lang.get('profile.stickers.address.form.country'),
								border: true,
								options: countries,
								value: 'LV'
							})
						]
					}
				]
			}).append(this._postalAddress);
			mkE({
				tag: 'div',
				className: 'form-row',
				els: [
					this._postalFields['address'] = new T.Form.Input({
						caption: D.Lang.get('profile.stickers.address.form.address'),
						border: true
					})
				]
			}).append(this._postalAddress);
		},

		_drawOmnivaForm: function () {
			let options = [{
				caption: D.Lang.get('profile.stickers.address.omniva.all'),
				value: 'all'
			}];
			for( let i = 0; i < this._omniva.cities.length; i++ ) {
				const omnivaCity = this._omniva.cities[i];
				options.push({
					caption: omnivaCity,
					value: omnivaCity
				});
			}
			mkE({
				tag: 'div',
				className: 'form-row form-row-2',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._omnivaFields['city'] = new T.Form.Select({
								caption: D.Lang.get('profile.stickers.address.omniva.city'),
								border: true,
								options: options,
								value: 'all',
								onChange: this._drawOmnivaItem
							})
						]
					},
					this._omnivaItemContainer = mkE({
						tag: 'div',
						className: 'right'
					})
				]
			}).append(this._omnivaAddress);
			mkE({
				tag: 'div',
				className: 'form-row form-row-2',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._omnivaFields['phone'] = new T.Form.Phone({
								caption: D.Lang.get('profile.stickers.address.omniva.phone'),
								border: true,
								code: 371,
								value: ''
							})
						]
					}
				]
			}).append(this._omnivaAddress);
			this._drawOmnivaItem();
		},

		_drawOmnivaItem: function () {
			let value = 'select';
			if( this._omnivaFields['item'] ) {
				value = this._omnivaFields['item'].value();
			}
			let city = this._omnivaFields['city'].value();
			let options = [];
			options.push({
				value: 'select',
				caption: D.Lang.get('profile.stickers.address.omniva.selectItem')
			});
			if( city === 'all' ) {
				for( let i = 0; i < this._omniva.locations.length; i++ ) {
					const location = this._omniva.locations[i];
					options.push({
						caption: location.city + ', ' + location.address + ' (' + location.name + ')',
						value: location.id
					});
				}
			} else {
				for( let i = 0; i < this._omniva.locationByCity[city].length; i++ ) {
					const location = this._omniva.locationByCity[city][i];
					options.push({
						caption: location.address + ' (' + location.name + ')',
						value: location.id
					});
				}
			}
			clearNode(this._omnivaItemContainer);
			this._omnivaFields['item'] = new T.Form.Select({
				caption: D.Lang.get('profile.stickers.address.omniva.item'),
				border: true,
				options: options,
				value: value
			}).append(this._omnivaItemContainer);
		},

		_getOmnivaData: function () {
			let phoneValue = this._omnivaFields['phone'].value();
			let phone = '';
			if( phoneValue ) {
				phone = '+' + phoneValue.code + phoneValue.value;
			}
			return {
				item: this._omnivaFields['item'].value(),
				phone: phone
			};
		},

		_getPostalData: function () {
			let data = {};
			for( let field in this._postalFields ) {
				if( !this._postalFields.hasOwnProperty(field) ) {
					continue;
				}
				data[field] = this._postalFields[field].value();
			}
			let phoneValue = this._postalFields['phone'].value();
			if( phoneValue ) {
				data.phone = '+' + phoneValue.code + phoneValue.value;
			}
			return data;
		},

		_checkAddress: function () {
			if( this._isCheckingAddress ) {
				return;
			}
			this._isCheckingAddress = true;
			let data = {};
			if( this._addressType === 'omniva' ) {
				data = this._getOmnivaData();
				for( let field in this._omnivaFields ) {
					if( !this._omnivaFields.hasOwnProperty(field) ) {
						continue;
					}
					this._omnivaFields[field].error(null);
				}
			} else {
				data = this._getPostalData();
				for( let field in this._postalFields ) {
					if( !this._postalFields.hasOwnProperty(field) ) {
						continue;
					}
					this._postalFields[field].error(null);
				}
			}
			this.rpc.send('checkStickersAddress', {
				type: this._addressType,
				data: data
			}, this._onCheckAddress);
		},

		_onCheckAddress: function ( data ) {
			this._isCheckingAddress = false;
			if( data.ok ) {
				this._wizard.nextStep();
				return;
			}
			let fields;
			if( this._addressType === 'postal' ) {
				fields = this._postalFields;
			} else {
				fields = this._omnivaFields;
			}
			for( let fieldName in data.errors ) {
				if( !data.errors.hasOwnProperty(fieldName) ) {
					continue;
				}
				let field = fields[fieldName];
				if( !field ) {
					continue;
				}
				field.error(D.Lang.get('profile.stickers.address.errors.' + fieldName + '.' + data.errors[fieldName]));
			}
		},

		_drawReview: function () {
			clearNode(this._reviewContainer);
			let titleElements = [];
			if( this._getPaidStickers && this._getPaidStickers.value() ) {
				titleElements.push(D.Lang.get('profile.stickers.review.paid'));
			}
			if( this._getFreeStickers && this._getFreeStickers.value() ) {
				titleElements.push(D.Lang.get('profile.stickers.review.free'));
			}
			let title = ucfirst(titleElements.join(' ' + D.Lang.get('profile.stickers.review.and') + ' '));
			mkE({
				tag: 'div',
				className: 'review-title',
				text: title
			}).append(this._reviewContainer);
			let shippingInfo = [];
			let billingInfo = [];
			if( this._addressType === 'postal' ) {
				let name = this._postalFields['name'].value();
				if( name ) {
					shippingInfo.push(name);
				}
				let phoneFields = this._postalFields['phone'].value();
				if( phoneFields ) {
					shippingInfo.push('+' + phoneFields.code + ' ' + phoneFields.value);
				}
				let address = this._postalFields['address'].value();
				if( address ) {
					shippingInfo.push(address);
				}
				let city = this._postalFields['city'].value();
				if( city ) {
					shippingInfo.push(city);
				}
				let zip = this._postalFields['zip'].value();
				if( zip ) {
					shippingInfo.push(zip);
				}
				let country = this._postalFields['country'].value();
				if( country ) {
					shippingInfo.push(D.countries[D.LANG][country]);
				}
			} else {
				let phoneFields = this._omnivaFields['phone'].value();
				if( phoneFields ) {
					shippingInfo.push('+' + phoneFields.code + ' ' + phoneFields.value);
				}
				let item = this._omnivaFields['item'].value();
				const omnivaLocation = this._omniva.getById(item);
				if( omnivaLocation ) {
					shippingInfo.push(omnivaLocation.city);
					shippingInfo.push(omnivaLocation.address);
					shippingInfo.push(omnivaLocation.name);
				}

				let billing = this._purchaseForm.getData();
				if( billing.type === 'private' ) {
					billingInfo.push(this.user.name + ' ' + this.user.surname);
				}
				if( billing.data['phone'] ) {
					billingInfo.push(billing.data['phone']);
				}
				if( billing.type === 'company' ) {
					if( billing.data['name'] ) {
						billingInfo.push(billing.data['name']);
					}
					if( billing.data['reg'] ) {
						billingInfo.push(billing.data['reg']);
					}
					if( billing.data['vat'] ) {
						billingInfo.push(billing.data['vat']);
					}
					if( billing.data['address'] ) {
						billingInfo.push(billing.data['address']);
					}
					if( billing.data['city'] ) {
						let text = billing.data['city'];
						if( billing.data['country'] ) {
							text = text + ', ' + D.countries[D.LANG][billing.data['country']];
						}
						billingInfo.push(text);
					}
				}
			}

			let shippingColumn = '';
			if( shippingInfo.length ) {
				let shippingData = mkE({
					tag: 'div',
					className: 'review-column-content'
				});
				for( let i = 0, l = shippingInfo.length; i < l; i++ ) {
					mkE({
						tag: 'div',
						text: shippingInfo[i]
					}).append(shippingData);
				}
				shippingColumn = mkE({
					tag: 'div',
					className: 'review-column',
					els: [
						{
							tag: 'div',
							className: 'review-column-caption',
							text: D.Lang.get('profile.stickers.review.shipping')
						},
						shippingData
					]
				});
			}
			let billingColumn = '';
			if( billingInfo.length ) {
				let billingData = mkE({
					tag: 'div',
					className: 'review-column-content'
				});
				for( let i = 0, l = billingInfo.length; i < l; i++ ) {
					mkE({
						tag: 'div',
						text: billingInfo[i]
					}).append(billingData);
				}
				billingColumn = mkE({
					tag: 'div',
					className: 'review-column',
					els: [
						{
							tag: 'div',
							className: 'review-column-caption',
							text: D.Lang.get('profile.stickers.review.billing')
						},
						billingData
					]
				});
			}
			mkE({
				tag: 'div',
				className: 'review-columns',
				els: [
					shippingColumn,
					billingColumn
				]
			}).append(this._reviewContainer);
			if( this._addressType === 'omniva' ) {
				mkE({
					tag: 'div',
					className: 'price-info',
					els: [
						{
							tag: 'h3',
							els: [
								{
									tag: 'span',
									text: '€15.00'
								}
							]
						}
					]
				}).append(this._reviewContainer);
				mkE({
					tag: 'div',
					className: 'purchase-disclaimer',
					els: [
						{
							tag: 'div',
							className: 'disclaimer',
							els: [
								D.Lang.get('profile.team.purchase.receiver'),
								{
									tag: 'br'
								},
								D.Lang.get('profile.team.purchase.address')
							]
						},
						{
							tag: 'img',
							src: '/assets/images/payments.svg'
						}
					]
				}).append(this._reviewContainer);
			}
		},

		_checkPaymentData: function () {
			if( this._isCheckingPayment ) {
				return;
			}
			this._purchaseForm.clearErrors();
			this._rulesCheckbox.error(null);
			let hasError = false;

			let data = this._purchaseForm.getData();
			let errors = {
				company: {}
			};

			if( data.type === 'company' ) {
				for( let field in data.data ) {
					if( !data.data.hasOwnProperty(field) ) {
						continue;
					}
					let value = data.data[field];
					if( !value && field !== 'vat' ) {
						errors.company[field] = 'empty';
						hasError = true;
					}
				}
			} else {
				let value = data.data['phone'];
				if( !value ) {
					errors['phone'] = 'empty';
					hasError = true;
				}
			}

			this._purchaseForm.setErrors(errors);

			if( !this._rulesCheckbox.value() ) {
				this._rulesCheckbox.error(D.Lang.get('profile.team.purchase.errors.rules'));
				hasError = true;
			}

			if( hasError ) {
				return true;
			}

			this._isCheckingPayment = true;
			this.rpc.send('checkPaymentData', {
				type: data.type,
				data: data.data
			}, this._onCheckPaymentData);
		},

		_onCheckPaymentData: function ( data ) {
			this._isCheckingPayment = false;
			if( data.ok ) {
				this._wizard.nextStep();
			}
			if( data.errors ) {
				this._purchaseForm.setErrors(data.errors);
			}
		},

		_getStickers: function () {
			if( this._isPurchasing ) {
				return;
			}
			let data = {};
			let paidStickers = false;
			if( this._getFreeStickers && this._getFreeStickers.value() ) {
				data.free = true;
			}
			if( this._getPaidStickers && this._getPaidStickers.value() ) {
				data.paid = true;
				paidStickers = true;
			}
			if( paidStickers ) {
				data.shipping = this._getOmnivaData();
				data.payment = this._purchaseForm.getData();
			} else {
				data.shipping = this._getPostalData();
			}
			this._isPurchasing = true;
			this.rpc.send('purchaseStickers', data, this._onPurchaseStickers);
		},

		_onPurchaseStickers: function ( data ) {
			if( data.ok ) {
				if( data.paymentId ) {
					this._paymentId = data.paymentId;
					D.onBraintree(this._onBraintree);
				} else {
					Section.navigate(D.url('/profile/event/' + this.event.seoTitle));
				}
				return;
			}
			this._isPurchasing = false;
			if( data.errors ) {
				let step = 0;
				if( data.errors.shipping ) {
					step = 1;
					this._onCheckAddress(data.errors.shipping);
				}
				if( data.errors.payment ) {
					this._purchaseForm.setErrors(data.errors.payment);
					if( !step ) {
						step = 2;
					}
				}
				if( step ) {
					this._wizard.setStep(step);
				}
			}
		},

		_onBraintree: function () {
			D.loadingOverlay(this.node);
			this._mGetBraintreeToken = new DR.services.GetBraintreeClientToken();
			this._mGetBraintreeToken.onLoad = this._onBraintreeToken;
			this._mGetBraintreeToken.onError = this._onBraintreeTokenError;
			this._mGetBraintreeToken.call({eventId: this.event.id});
		},

		_onBraintreeToken: function () {
			this._braintreeToken = this._mGetBraintreeToken.re.token;
			this._createBraintree();
		},

		_onBraintreeTokenError: function () {

		},

		_createBraintree: function () {
			D.removeLoadingOverlay(this.node);
			this._braintreePopup = new T.Popup({
				className: 'popup-payment',
				overlayClick: false
			});
			this._braintreeContainer = mkE({
				tag: 'div',
				els: [
					{
						tag: 'div',
						id: 'braintree-container'
					},
					this._braintreeButton = mkE({
						tag: 'button',
						className: 'button button-pink button-block button-disabled',
						text: D.Lang.get('profile.stickers.purchase'),
						style: {
							marginTop: '12px'
						}
					})
				]
			});
			this._braintreePopup.setContent(this._braintreeContainer);
			let braintreeParams = {
				authorization: this._braintreeToken,
				container: '#braintree-container',
				card: {
					cardholderName: true
				},
				translations: D.LANG === 'lv' ? D.Lang.getBraintree() : null,
				vaultManager: true
			};
			if( D.BRAINTREE_3DS_ENABLED ) {
				braintreeParams.threeDSecure = true;
			}
			braintree.dropin.create(braintreeParams, this._onBraintreeCreate);
			this._braintreePopup.open();
		},

		_onBraintreeCreate: function ( createErr, instance ) {
			this._braintreeInstance = instance;
			this._braintreeButton.addEventListener('click', this._onBraintreeMethodSelect);
			removeClassName(this._braintreeButton, 'button-disabled');
		},

		_onBraintreeMethodSelect: function () {
			if( this._errorNode ) {
				this._errorNode.remove();
				delete this._errorNode;
			}
			let params = {};
			if( D.BRAINTREE_3DS_ENABLED ) {
				params.threeDSecure = {
					amount: (this._price / 100).toFixed(2),
					email: this.user.email
				};
			}
			this._braintreeInstance.requestPaymentMethod(params, this._onBraintreeMethodData);
		},

		_onBraintreeMethodData: function ( requestPaymentMethodErr, payload ) {
			if( requestPaymentMethodErr ) {
				console.log(requestPaymentMethodErr);
				/*this._errorNode = T.fatal(D.Lang.get('profile.team.purchase.errors.cancelled'));
				D.insertBefore(this._errorNode, this._braintreeContainer);*/
			} else if( payload.nonce ) {
				D.loadingOverlay(this.node);
				this._mProcessBraintree = new DR.services.ProcessBraintreeTransaction();
				this._mProcessBraintree.nonce = payload.nonce;
				this._mProcessBraintree.paymentId = this._paymentId;
				this._mProcessBraintree.onLoad = this._onBraintreeSuccess;
				this._mProcessBraintree.onError = this._onBraintreeError;
				this._mProcessBraintree.call({eventId: this.event.id});
				this._braintreePopup.close();
			}
		},

		_onBraintreeSuccess: function () {
			let re = this._mProcessBraintree.re;
			if( re.ok ) {
				Section.navigate(D.url('/profile/event/' + this.event.seoTitle))
			} else {
				D.removeLoadingOverlay(this.node);
				let text = D.Lang.get('profile.team.purchase.errors.cancelled');
				if( re.errors.length ) {
					text = re.errors[0];
				}
				this._errorNode = T.fatal(text).append(this._errorHolder);
			}
		},

		_onBraintreeError: function () {
			D.removeLoadingOverlay(this.node);
			this._errorNode = T.fatal(D.Lang.get('profile.team.purchase.errors.cancelled')).append(this._errorHolder);
		}
	},
	SectionProfile.EventBase
);

SectionProfile.Event.Stickers.Omniva = Class(
	/**
	 * @lends {SectionProfile.Event.Stickers.Omniva#}
	 */
	{
		locations: [],
		cities: [],
		locationByCity: {},
		locationById: {},

		/** @param {DR.ApiCall} apiCall */
		__construct: function ( apiCall ) {
			this._mGetOmnivaLocations = new DR.services.GetOmnivaLocations();
			this._mGetOmnivaLocations.onLoad = this._mGetOmnivaLocationsRe;
			apiCall.addMethod(this._mGetOmnivaLocations);
		},
		_mGetOmnivaLocationsRe: function () {
			this.locations = this._mGetOmnivaLocations.re.locations;

			for( let i = 0; i < this.locations.length; i++ ) {
				const location = this.locations[i];
				if( typeof this.locationByCity[location.city] === "undefined" ) {
					this.locationByCity[location.city] = [];
					this.cities.push(location.city);
				}
				this.locationByCity[location.city].push(location);
				this.locationById[location.id] = location;
			}

			this.locations.sort(function ( a, b ) {
				return a.city > b.city;
			});
		},
		/** @returns {DR.services.struct.OmnivaLocation[]} */
		getById: function ( id ) {
			return this.locationById[id];
		},
		/** @returns {DR.services.struct.OmnivaLocation[]} */
		getByCity: function ( city ) {
			return this.locationByCity[city];
		},
		/** @returns {DR.services.struct.OmnivaLocation[]} */
		getSorted: function () {
			return this.locations;
		},
		getCities: function () {
			return this.cities;
		}
	}
);
